module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/01_ripple_effect.png";